import { useEffect, useState, useRef } from 'react';
import { mapApiValidationService, MapApiValidationState } from '../../../services/mapApiValidationService';

interface MapApiValidationResult {
    isValid: boolean;
    isChecking: boolean;
    error?: string | null;
}

/**
 * Hook that uses the global map API validation service
 * Prevents duplicate requests when multiple components need to validate the API
 * Returns loading state and validity status
 */
export const useMapApiValidation = (): MapApiValidationResult => {
    const [state, setState] = useState<MapApiValidationState>({
        isValid: false,
        isChecking: true,
        lastChecked: 0,
        error: null,
    });
    const subscriptionIdRef = useRef<string | null>(null);

    useEffect(() => {
        // Subscribe to the global validation service
        const subscriptionId = mapApiValidationService.subscribe((newState) => {
            setState(newState);
        });
        
        subscriptionIdRef.current = subscriptionId;

        // Cleanup subscription on unmount
        return () => {
            if (subscriptionIdRef.current) {
                mapApiValidationService.unsubscribe(subscriptionIdRef.current);
            }
        };
    }, []);

    return {
        isValid: state.isValid,
        isChecking: state.isChecking,
        error: state.error,
    };
};
